export default __webpack_public_path__ + "d7475e39f70533c40ca5957baa0c6f93.woff2";